<div class="layout">
  <app-header class="header"></app-header>
  <app-sidebar class="sidebar"></app-sidebar>
  <main class="main" toastContainer aria-live="polite">
    <app-loading-overlay />
    <router-outlet />
  </main>
</div>
